import { bindable } from "aurelia-typed-observable-plugin";
import { CustomElementBase } from "app/shared/elements/custom-element-base";
import { guid } from "app/shared/lib/guid";

interface IFormControl {
    autocomplete: string;
    readonly: boolean;
    disabled: boolean;
}

/**
 * General input element.
 */
export interface IInput extends IFormControl {
    value: any;
    label: string | null;
    placeholder: string | null;
    required: boolean;
}

/**
 * A date range input element.
 */
export interface IDateRangeInput extends IFormControl {
    startDate: string | null;
    endDate: string | null;
    label: string | null;
    placeholder: string | null;
    required: boolean;
}

/**
 * Boolean input elements.
 */
export interface IToggle extends IFormControl {
    checked: boolean | null;
}

/**
 * Base class for input custom elements.
 */
export abstract class InputBase extends CustomElementBase implements IInput {

    public abstract value: unknown;

    @bindable.stringNull()
    public label: string | null = null;

    @bindable.stringNull()
    public placeholder: string | null = null;

    // @bindable.stringNull()
    public icon: string | null = null;

    @bindable.booleanAttr()
    public required: boolean = false;

    @bindable.booleanAttr()
    public readonly: boolean = false;

    @bindable.booleanAttr()
    public disabled: boolean = false;

    @bindable.string()
    public autocomplete: string = 'off';

    protected id: guid = guid();

    protected abstract $inputElement: HTMLElement;
}
